<div class="container-main">
  <div class="left-side" tabindex="1">
    <section class="container">
      <form [formGroup]="fullTextLookupForm">
        <div
          class="fulltext-info top-bottom"
          i18n="@@FullTextLookupComponentTitle"
        >
          Full Text Lookup (Optional)
        </div>
        <section>
          <div class="input-field">
            <label i18n="@@FullTextLookupComponentTrademarkNumberLabel"
              >Trademark Number</label
            >
            <mat-form-field appearance="outline">
              <input
                matInput
                formControlName="trademarkNumber"
                maxlength="100"
                placeholder="Enter Trademark Number"
                i18n-placeholder="
                  @@FullTextLookupComponentTrademarkNumberPlaceholder"
              />
            </mat-form-field>
          </div>
        </section>
        <section>
          <div class="input-field">
            <label i18n="@@FullTextLookupComponentRegisterLabel"
              >Register</label
            >
            <mat-form-field appearance="outline">
              <mat-select
                disableOptionCentering
                formControlName="register"
                placeholder="Select a Register"
                i18n-placeholder="@@FullTextLookupComponentRegisterPlaceholder"
              >
                @for (register of registers; track register) {
                <mat-option [value]="register">
                  {{ register.split('-').pop() }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </section>
        <section class="line">
          <button
            mat-flat-button
            color="primary"
            class="marginBottom"
            [disabled]="isButtonDisabled()"
            (click)="findFullTextInfoClick()"
            i18n="@@FullTextLookupComponentFindFullTextInformationBtn"
          >
            Find Full Text Information
          </button>
        </section>
      </form>
      @if (fullTextDetails) {
      <section class="result-case">
        <div>
          @if (fullTextDetails.length === 0) {
          <span
            class="no-result"
            i18n="@@FullTextLookupComponentNoResultsMessage"
          >
            No results found. Please refine your search criteria or contact your
            local customer support.
          </span>
          } @else { @if (fullTextDetails.length > 10) {
          <span
            class="no-result"
            i18n="@@FullTextLookupComponentTooManyResultsMessage"
          >
            Your query returned too many results. Please refine your search
            criteria.
          </span>
          } @else { @for (item of fullTextDetails; track item; let i = $index) {
          <ng-container
            *ngTemplateOutlet="displayContent; context: { $implicit: item }"
          ></ng-container>
          <div class="item-divider"></div>
          } } }
        </div>
      </section>
      }
    </section>
  </div>
  <div class="right-side" tabindex="1">
    <section>
      <div class="fulltext-info top-bottom">Currently Added</div>
      @if (selectedFullTextDetails.size > 0) {
      <div>
        @for (item of selectedFullTextDetails; track item; let i = $index) {
        <ng-container
          *ngTemplateOutlet="displayContent; context: { $implicit: item }"
        ></ng-container>
        }
      </div>
      } @else {
      <div
        class="no-selection"
        i18n="@@FullTextLookupComponentNoFullTextAddedYet"
      >
        No Full Text information has been added yet.
      </div>
      }
    </section>
  </div>
</div>
<ng-template #displayContent let-item>
  <div class="result">
    <div class="left-sect">
      <div class="row">
        <span class="center"
          >@if (item.selected) {
          <mat-icon class="icon check">check_circle</mat-icon>
          }</span
        >
        <label>{{ item.trademarkName }}</label>
      </div>
      <div class="row">
        <span class="vertical-line-container">{{ item.trademarkNumber }}</span>
        <span class="vertical-line-container">{{ item.filingStatus }}</span>
        <span>{{ item.register.split('-').pop() }}</span>
      </div>
    </div>
    <div class="right-sect">
      <a
        class="vertical-line-container view-color"
        [routerLink]="[
          '/order-management/fulltext',
          item.trademarkNumber,
          item.register,
          item.trademarkGuid
        ]"
        target="_blank"
        >View</a
      >
      @if (!item.selected) {
      <button
        (click)="toggleSelection(item)"
        class="cdx-but-md"
        color="primary"
        mat-stroked-button
        i18n="@@FullTextLookupComponentAddToOrderBtn"
      >
        Add to Order
      </button>
      } @else {
      <mat-icon
        class="delete-icon"
        matTooltipPosition="below"
        matTooltip="Remove Full Text"
        (click)="toggleSelection(item)"
      >
        delete_outline
      </mat-icon>
      }
    </div>
  </div>
</ng-template>
